import { render, staticRenderFns } from "./OrganizationReimagine.vue?vue&type=template&id=0f3e4570&scoped=true&"
import script from "./OrganizationReimagine.vue?vue&type=script&lang=js&"
export * from "./OrganizationReimagine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3e4570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f3e4570')) {
      api.createRecord('0f3e4570', component.options)
    } else {
      api.reload('0f3e4570', component.options)
    }
    module.hot.accept("./OrganizationReimagine.vue?vue&type=template&id=0f3e4570&scoped=true&", function () {
      api.rerender('0f3e4570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/organization/OrganizationReimagine.vue"
export default component.exports